/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as DocumentsRouteImport } from './routes/documents'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MailingRouteImport } from './routes/mailing'
import { Route as MembersRouteImport } from './routes/members'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TransactionsRouteImport } from './routes/transactions'
import { Route as TreasuryRouteImport } from './routes/treasury'
import { Route as OrdersIdRouteImport } from './routes/orders.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsRoute = DocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MailingRoute = MailingRouteImport.update({
  id: '/mailing',
  path: '/mailing',
  getParentRoute: () => rootRouteImport,
} as any)
const MembersRoute = MembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsRoute = TransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const TreasuryRoute = TreasuryRouteImport.update({
  id: '/treasury',
  path: '/treasury',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIdRoute = OrdersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => OrdersRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/documents': typeof DocumentsRoute
  '/login': typeof LoginRoute
  '/mailing': typeof MailingRoute
  '/members': typeof MembersRoute
  '/orders': typeof OrdersRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/transactions': typeof TransactionsRoute
  '/treasury': typeof TreasuryRoute
  '/orders/$id': typeof OrdersIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/documents': typeof DocumentsRoute
  '/login': typeof LoginRoute
  '/mailing': typeof MailingRoute
  '/members': typeof MembersRoute
  '/orders': typeof OrdersRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/transactions': typeof TransactionsRoute
  '/treasury': typeof TreasuryRoute
  '/orders/$id': typeof OrdersIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/documents': typeof DocumentsRoute
  '/login': typeof LoginRoute
  '/mailing': typeof MailingRoute
  '/members': typeof MembersRoute
  '/orders': typeof OrdersRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/transactions': typeof TransactionsRoute
  '/treasury': typeof TreasuryRoute
  '/orders/$id': typeof OrdersIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/documents'
    | '/login'
    | '/mailing'
    | '/members'
    | '/orders'
    | '/reset-password'
    | '/transactions'
    | '/treasury'
    | '/orders/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/documents'
    | '/login'
    | '/mailing'
    | '/members'
    | '/orders'
    | '/reset-password'
    | '/transactions'
    | '/treasury'
    | '/orders/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/documents'
    | '/login'
    | '/mailing'
    | '/members'
    | '/orders'
    | '/reset-password'
    | '/transactions'
    | '/treasury'
    | '/orders/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  DocumentsRoute: typeof DocumentsRoute
  LoginRoute: typeof LoginRoute
  MailingRoute: typeof MailingRoute
  MembersRoute: typeof MembersRoute
  OrdersRoute: typeof OrdersRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  TransactionsRoute: typeof TransactionsRoute
  TreasuryRoute: typeof TreasuryRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents': {
      id: '/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mailing': {
      id: '/mailing'
      path: '/mailing'
      fullPath: '/mailing'
      preLoaderRoute: typeof MailingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/members': {
      id: '/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof MembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/treasury': {
      id: '/treasury'
      path: '/treasury'
      fullPath: '/treasury'
      preLoaderRoute: typeof TreasuryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$id': {
      id: '/orders/$id'
      path: '/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof OrdersIdRouteImport
      parentRoute: typeof OrdersRoute
    }
  }
}

interface OrdersRouteChildren {
  OrdersIdRoute: typeof OrdersIdRoute
}

const OrdersRouteChildren: OrdersRouteChildren = {
  OrdersIdRoute: OrdersIdRoute,
}

const OrdersRouteWithChildren =
  OrdersRoute._addFileChildren(OrdersRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  DocumentsRoute: DocumentsRoute,
  LoginRoute: LoginRoute,
  MailingRoute: MailingRoute,
  MembersRoute: MembersRoute,
  OrdersRoute: OrdersRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  TransactionsRoute: TransactionsRoute,
  TreasuryRoute: TreasuryRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
